import { render, staticRenderFns } from "./ItemCreateErrors.vue?vue&type=template&id=1cb4c01a"
import script from "./ItemCreateErrors.vue?vue&type=script&lang=js"
export * from "./ItemCreateErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports